<template>
    <div class="table-wrapper" style="padding-top: 20px;">
        <Form ref="formInline" :model="formInline" inline class="form-list"
            :label-width="100" label-position="right">
            <Row :gutter="16">
                <Col span='3'>
                    <Button type="primary" icon="ios-exit-outline"
                            @click="handleExport">导出</Button>
                    <Tooltip placement="right" theme="light" transfer max-width="initial">
                    <span><Icon type="ios-help-circle-outline" /></span>
                    <ul slot="content">
                        <li>注：1.系统支持查询截止2小时之前的考勤数据情况。</li>
                    </ul>
                </Tooltip>
                </Col>
                <Col span="6" offset="6">
                    <FormItem label="时间选择:">
                        <template>
                            <el-date-picker
                                class="marL"
                                v-model="formInline.time"
                                type="date"
                                :picker-options="pickerOptions"
                                placeholder="请选择一天" @change="timeChange"
                                >
                            </el-date-picker>
                        </template>
                        <!-- <DatePicker type="daterange" v-model="formInline.time" split-panels placeholder="请选择" @on-change="timeChange" ></DatePicker> -->
                    </FormItem>
                </Col>
                <Col span="6">
                    <FormItem label="项目所在地：">
                        <Select v-model="areaCode" clearable>
                            <Option v-for="item in dictArea" :value="item.value" :key="item.value">{{ item.label }}</Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col span="3">
                    <Button style="margin-left: 20px;float:right;" @click="handleReset()">重置</Button>
                    <Button style="float: right;" type="primary" @click="handleQuery">搜索</Button>
                </Col>
            </Row>
        </Form>
        <Table border :loading="loading" :columns="tableColumns" :data="tableData" highlight-row>
            <template slot-scope="{ row, index }" slot="action">
                <span class="pointer" type="text" size="small" @click="handleDeal('theWorkAnalysisDetailProject',row,row.projectWorkerId)" v-if="row.areaName !== '合计'">详情</span>
            </template>
        </Table>
        <!-- <div class="t-page">
            <Page :total="totalCount" :page-size="pageSize" :current="page"
                @on-change="changePage" @on-page-size-change="pageSizeChange"
                show-elevator show-sizer show-total transfer>
            </Page>
        </div> -->
    </div>
</template>
<style scoped>

</style>
<script>
    import {mapState} from 'vuex';
    import tableMixin from '@/components/tableMixin';
    import {format} from "../../../utils/forMat";
    import dataTime from '@/components/dataTimeMixin'
    export default {
        mixins: [tableMixin,dataTime],
        data(){
            return {
                dictArea: [],
                areaCode: '',
                formOutLine1: {
                    startDate:'',
                    endDate:''
                },
                tableColumns:[
                    {
                        title: '序号',
                        type: 'index',
                        width: 70,
                        align: 'center'
                    },
                    {
                        title: '地区',
                        key: 'areaName',
                        minWidth:100,
                    },
                    {
                        title: '在建项目数',
                        key: 'buildingCount',
                        minWidth:150,
                        sortable: true,
                        align: 'right'
                    },
                    {
                        title: '管理人员到岗项目数',
                        key: 'managerToPostProjectCount',
                        minWidth:180,
                        align: 'right',
                        sortable: true,
                        renderHeader: (h, params) => {
                            return h('div', [
                                h('span', '管理人员到岗项目数'),
                                h('Tooltip', {
                                    props:{
                                        placement: 'right',
                                        theme: 'light',
                                        transfer: true,
                                        content: '是指区域内有管理人员出勤的项目总数;'
                                    }
                                },[
                                    h('Icon', {
                                        props: {
                                            type: 'ios-help-circle-outline'
                                        }
                                    })
                                ]),

                            ]);
                        }
                    },
                    {
                        title: '综合平均到岗率',
                        key: 'synthesizeAverageToPostRate',
                        minWidth:150,
                        align: 'right',
                        sortable: true,
                        sortMethod: (a,b, type) => {
                            let na = Number(a.replace('%', ''));
                            let nb = Number(b.replace('%', ''));
                            if(type === 'desc') {
                                return nb - na
                            }else {
                                return na - nb
                            }
                        },
                        renderHeader: (h, params) => {
                            return h('div', [
                                h('span', '综合平均到岗率'),
                                h('Tooltip', {
                                    props:{
                                        placement: 'right',
                                        theme: 'light',
                                        transfer: true,
                                        content: '是指所在区域内在建项目的管理人员出勤总人数/区域内在建项目的管理人员在岗总人数;'
                                    }
                                },[
                                    h('Icon', {
                                        props: {
                                            type: 'ios-help-circle-outline'
                                        }
                                    })
                                ]),

                            ]);
                        }
                    },
                    {
                        title: '施工总承包单位平均到岗率',
                        key: 'buildAverageToPostRate',
                        minWidth:220,
                        align: 'right',
                        sortable: true,
                        sortMethod: (a,b, type) => {
                            let na = Number(a.replace('%', ''));
                            let nb = Number(b.replace('%', ''));
                            if(type === 'desc') {
                                return nb - na
                            }else {
                                return na - nb
                            }
                        },
                        renderHeader: (h, params) => {
                            return h('div', [
                                h('span', '施工总承包单位平均到岗率'),
                                h('Tooltip', {
                                    props:{
                                        placement: 'right',
                                        theme: 'light',
                                        transfer: true,
                                        content: '是指所在区域内在建项目的施工总承包单位管理人员出勤总人数/区域内在建项目的施工总承包单位管理人员在岗总人数;'
                                    }
                                },[
                                    h('Icon', {
                                        props: {
                                            type: 'ios-help-circle-outline'
                                        }
                                    })
                                ]),

                            ]);
                        }
                    },
                    {
                        title: '施工总承包单位项目经理平均到岗率',
                        key: 'buildManagerAverageToPostRate',
                        minWidth:270,
                        align: 'right',
                        sortable: true,
                        sortMethod: (a,b, type) => {
                            let na = Number(a.replace('%', ''));
                            let nb = Number(b.replace('%', ''));
                            if(type === 'desc') {
                                return nb - na
                            }else {
                                return na - nb
                            }
                        },
                        renderHeader: (h, params) => {
                            return h('div', [
                                h('span', '施工总承包单位项目经理的平均到岗率'),
                                h('Tooltip', {
                                    props:{
                                        placement: 'right',
                                        theme: 'light',
                                        transfer: true,
                                        content: '是指所在区域内在建项目的施工总承包单位的有效项目经理出勤总人数/区域内在建项目的施工总承包单位的项目经理在岗总人数'
                                    }
                                },[
                                    h('Icon', {
                                        props: {
                                            type: 'ios-help-circle-outline'
                                        }
                                    })
                                ]),

                            ]);
                        }
                    },
                    {
                        title: '监理单位平均到岗率',
                        key: 'supervisionAverageToPostRate',
                        minWidth:200,
                        align: 'right',
                        sortable: true,
                        sortMethod: (a,b, type) => {
                            let na = Number(a.replace('%', ''));
                            let nb = Number(b.replace('%', ''));
                            if(type === 'desc') {
                                return nb - na
                            }else {
                                return na - nb
                            }
                        },
                        renderHeader: (h, params) => {
                            return h('div', [
                                h('span', '监理单位平均到岗率'),
                                h('Tooltip', {
                                    props:{
                                        placement: 'right',
                                        theme: 'light',
                                        transfer: true,
                                        content: '是指所在区域内在建项目的监理单位管理人员出勤总人数/区域内在建项目的监理单位管理人员在岗总人数;'
                                    }
                                },[
                                    h('Icon', {
                                        props: {
                                            type: 'ios-help-circle-outline'
                                        }
                                    })
                                ]),

                            ]);
                        }
                    },
                    {
                        title: '监理单位总监理工程师的平均到岗率',
                        key: 'supervisionManagerAverageToPostRate',
                        minWidth:250,
                        align: 'right',
                        sortable: true,
                        sortMethod: (a,b, type) => {
                            let na = Number(a.replace('%', ''));
                            let nb = Number(b.replace('%', ''));
                            if(type === 'desc') {
                                return nb - na
                            }else {
                                return na - nb
                            }
                        },
                        renderHeader: (h, params) => {
                            return h('div', [
                                h('span', '监理单位总监理工程师的平均到岗率'),
                                h('Tooltip', {
                                    props:{
                                        placement: 'right',
                                        theme: 'light',
                                        transfer: true,
                                        content: '是指所在区域内在建项目的监理单位的有效总监理工程师出勤总人数/区域内在建项目的监理单位的总监理工程师在岗总人数;'
                                    }
                                },[
                                    h('Icon', {
                                        props: {
                                            type: 'ios-help-circle-outline'
                                        }
                                    })
                                ]),

                            ]);
                        }
                    },
                    {
                        title: '建设单位平均到岗率',
                        key: 'constructionAverageToPostRate',
                        minWidth:200,
                        align: 'right',
                        sortable: true,
                        sortMethod: (a,b, type) => {
                            let na = Number(a.replace('%', ''));
                            let nb = Number(b.replace('%', ''));
                            if(type === 'desc') {
                                return nb - na
                            }else {
                                return na - nb
                            }
                        },
                        renderHeader: (h, params) => {
                            return h('div', [
                                h('span', '建设单位平均到岗率'),
                                h('Tooltip', {
                                    props:{
                                        placement: 'right',
                                        theme: 'light',
                                        transfer: true,
                                        content: '是指所在区域内在建项目的建设单位管理人员出勤总人数/区域内在建项目的建设单位管理人员在岗总人数;'
                                    }
                                },[
                                    h('Icon', {
                                        props: {
                                            type: 'ios-help-circle-outline'
                                        }
                                    })
                                ]),

                            ]);
                        }
                    },
                    {
                        title: '其他单位平均到岗率',
                        key: 'otherAverageToPostRate',
                        minWidth:200,
                        align: 'right',
                        sortable: true,
                        sortMethod: (a,b, type) => {
                            let na = Number(a.replace('%', ''));
                            let nb = Number(b.replace('%', ''));
                            if(type === 'desc') {
                                return nb - na
                            }else {
                                return na - nb
                            }
                        },
                        renderHeader: (h, params) => {
                            return h('div', [
                                h('span', '其他单位平均到岗率'),
                                h('Tooltip', {
                                    props:{
                                        placement: 'right',
                                        theme: 'light',
                                        transfer: true,
                                        content: '是指所在区域内在建项目其他单位管理人员出勤总人数/区域内在建项目其他单位管理人员在岗总人数(其他单位是指除施工总承包单位、监理单位、建设单位以外的参建单位);'
                                    }
                                },[
                                    h('Icon', {
                                        props: {
                                            type: 'ios-help-circle-outline'
                                        }
                                    })
                                ]),

                            ]);
                        }
                    },
                    {
                        title: '操作',
                        slot: 'action',
                        fixed: 'right',
                        align: 'center',
                        width: 100
                    }
                ],
                tableData:[],
                exportData:{
                    size:this.pageSize,
                    current:this.page,
                    areaCode:this.areaCode,
                },
            };
        },
        computed:{
            ...mapState(['area']),
        },
        created(){

        },
        mounted(){
            this.areaCode = this.$route.query.areaCode
            this.getTableData()
            this.getDictCode()
        },
        watch: {
            // '$route': function (to, from) {
            //     if(to.name==='checking-inList'){
            //         this.getTableData();
            //     }
            // },
            areaCode: function (val) {
                if(!val) {
                    this.areaCode = this.$route.query.areaCode
                }
            },
        },
        methods: {
            getDictCode() {
                this.axios({
                    method: 'get',
                    url: '/dict/area/' + this.areaCode,
                }).then( (response)=> {
                    console.log(response)
                    this.dictArea = response.data.data
                }).catch( ()=> {

                });
            },
            handleReset() {
                this.page = 1
                this.formInline = {
                    startDate:'',
                    endDate:'',
                    time: ''
                }
                this.areaCode = this.$route.query.areaCode
                this.getTableData()
            },
            timeChange(val) {
                console.log(val)
                this.formInline.startDate = format(val,"yyyy-MM-dd")
                this.formInline.endDate = format(val,"yyyy-MM-dd")
            },
            //导出
            handleExport(){
                let param={
                    startDate: this.formInline.startDate,
                    endDate: this.formInline.endDate,
                    // size:this.pageSize,
                    // current:this.page,
                    areaCode: this.areaCode,
                };
                this.axios({
                    method: 'post',
                    url:'/managerToPost/expot',
                    responseType:'arraybuffer',
                    data:param
                }).then( (response)=> {
                    this.common.download(response, '管理人员到岗统计.xls','application/vnd.ms-excel')
                });
            },
            /*处理操作*/
            handleDeal(name,row,uuid){
                let routeName = '';
                if(row.haveChildArea){
                    routeName = 'theWorkAnalysisDetail'
                }else{
                    routeName = 'theWorkAnalysisDetailProject'
                }
                this.$router.push({
                    name: routeName,
                    query: {
                        areaCode: row.areaCode,
                        projectWorkerId:uuid,
                        areaName:row.areaName
                    }
                });
            },
            /*获取表格数据*/
            getTableData(){
                let param={
                    startDate: this.formInline.startDate,
                    endDate: this.formInline.endDate,
                    size:this.pageSize,
                    current:this.page,
                    areaCode: this.areaCode,
                };
                this.exportData=param;
                this.loading=true;
                this.axios({
                    method: 'post',
                    url: '/managerToPost/statisticsList',
                    data:param
                }).then( (response)=> {
                    this.loading=false;
                    console.log(response)
                    if (response.data.success){
                        // this.totalCount = response.data.data.total
                        this.tableData=response.data.data
                    }
                }).catch( ()=> {
                    this.loading=false;
                });
            },
        }
    };
</script>
<style scoped >
    .dataTab .ivu-tabs-bar {
        margin-bottom: 0;
        border-bottom: none;
    }
    .marL{
       width:100%;
       height:32px;
   }
   .marL>>>.el-input__inner{
       display: inline-block;
       height:32px;
   }
   .marL>>>.el-icon-date{
       margin-left:-9px;
       font-size: 14px;
       /* margin-top:-8px; */

    color: #C0C4CC;
    float: left;
    line-height: 32px;

   }
   .marL>>>.el-range-separator{
       margin-top:-8px ;
       display: inline-block;
       width:16%;
   }
   .marL >>> .el-range__close-icon{
       margin-top:-8px;
   }
   .marL >>> .el-input__suffix .el-input__icon{
       height:32px;
       line-height: 32px;
   }
</style>
